// src/components/LoginAlertProvider/LoginAlertProvider.js
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FormattedMessage, useIntl } from '../../util/reactIntl'
/**
 * LoginAlertProvider - Componente que escucha cambios de autenticación
 * y muestra alertas según el tipo de usuario
 */
const LoginAlertProvider = ({ children }) => {
  //console.log('🔵 LoginAlertProvider renderizado');
  const intl = useIntl();

  const currentUser = useSelector(state => state.user?.currentUser);
  const isAuthenticated = useSelector(state => state.auth?.isAuthenticated);
  const loginInProgress = useSelector(state => state.auth?.loginInProgress);
  
  // Useref para trackear si ya mostramos la alerta en esta sesión
  const hasShownAlert = useRef(false);
  const previousAuthState = useRef(false);

  useEffect(() => {
    /*
    console.log('🟢 LoginAlertProvider useEffect ejecutado', {
      isAuthenticated,
      loginInProgress,
      hasCurrentUser: !!currentUser,
      previousAuthState: previousAuthState.current,
      hasShownAlert: hasShownAlert.current
    });
    */
    // Detectar cuando el usuario acaba de hacer login
    const justLoggedIn = !previousAuthState.current && isAuthenticated && !loginInProgress;
    
    //console.log('🟡 justLoggedIn:', justLoggedIn);
    
    if (justLoggedIn && currentUser && !hasShownAlert.current) {
      const userType = currentUser.attributes?.profile?.publicData?.userType;
      let isPayedAccount = false;//currentUser.attributes?.profile?.publicData?.isPayedAccount;
      if(currentUser.attributes?.profile?.privateData?.subscriptionStatus && currentUser.attributes?.profile?.privateData?.subscriptionStatus === 'authorized') {
        isPayedAccount = true;
      }
      
      //console.log('🟣 Datos del usuario:', { userType, isPayedAccount });
      
      /*
      // Solo mostrar para tiendas oficiales no suscritas
      if (userType === 'tienda-oficial' && !isPayedAccount) {
        //console.log('🔴 Mostrando alerta de suscripción');
        // Delay para asegurar que el UI esté listo
        setTimeout(() => {
          const subscriptionUrl = `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/account/subscriptions`;
          toast.warning(
            <div>
               {intl.formatMessage({ id: 'MessagesAlert.rememberSuscription' })}{' '}
              <a 
                href={subscriptionUrl} 
                style={{ 
                  color: '#ffffff', 
                  textDecoration: 'underline',
                  fontWeight: 'bold'
                }}
              >
                {intl.formatMessage({ id: 'MessagesAlert.subscribe' })}
              </a>
            </div>,
            {
              position: "top-center",
              autoClose: 8000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              theme: "colored",
              style: {
                width: '100%',
                fontSize: '15px',
                fontWeight: '500',
                padding: '16px 40px 16px 20px',
                color: '#ffffff',
                backgroundColor: '#d9534f',//'var(--colorAttention)',//'#d9534f',
              }
            }
          );
          hasShownAlert.current = true;
        }, 1000);
      }
      */
      
      if(process.env.REACT_APP_COUNTRY_CODE === 'AR') {
        
        const isCensorodanteroUrl = typeof window !== 'undefined' && window.location.href.includes('censorodantero');

        // Mostrar para todos los usuarios
        //if (userType === 'tienda-oficial' && !isPayedAccount) {
          //console.log('🔴 Mostrando alerta de suscripción');
          // Delay para asegurar que el UI esté listo
          if (!isCensorodanteroUrl) {
            setTimeout(() => {
            const subscriptionUrl = `${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/censorodantero`;
            toast.warning(
              <div>
                Para participar del sorteo de la casa rodante Dako 250, completá el censo: 
                <a 
                  href={subscriptionUrl} 
                  style={{ 
                    color: '#ffffff', 
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    marginLeft: '5px',
                  }}
                >
                  Censate
                </a>
              </div>,
              {
                position: "top-center",
                autoClose: 8000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                style: {
                  width: '100%',
                  fontSize: '15px',
                  fontWeight: '500',
                  padding: '16px 40px 16px 20px',
                  color: '#ffffff',
                  backgroundColor: '#29952d',//'var(--colorAttention)',//'#d9534f',
                }
              }
            );
            hasShownAlert.current = true;
            }, 1000);
          }
        //}

      }

    }
    
    // Actualizar el estado previo
    previousAuthState.current = isAuthenticated;
    
    // Reset cuando el usuario hace logout
    if (!isAuthenticated) {
      hasShownAlert.current = false;
    }
  }, [isAuthenticated, loginInProgress, currentUser]);

  return children;
};

export default LoginAlertProvider;